import React, { useState } from 'react';
import {
  Box, Container, Typography, Grid, Card, CardContent,
  Button, Avatar, Chip, Paper, Tabs, Tab, List, ListItem,
  ListItemText, ListItemAvatar, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow
} from '@mui/material';
import {
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  MedicalServices as MedicalIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
  CheckCircle as CheckIcon,
  Schedule as ScheduleIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const EmployeePortal = () => {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  const mockEmployee = {
    name: 'Dr. Sarah Johnson',
    email: 'sarah.johnson@hbmg-hospital.digital',
    role: 'Doctor',
    department: 'Hepatology',
    employeeId: 'EMP-001'
  };

  const mockPatients = [
    { id: 1, name: 'John Doe', appointment: '2026-07-25 10:00', status: 'Scheduled' },
    { id: 2, name: 'Jane Smith', appointment: '2026-07-25 11:30', status: 'In Progress' },
    { id: 3, name: 'Robert Brown', appointment: '2026-07-25 14:00', status: 'Completed' },
  ];

  return (
    <Box sx={{ bgcolor: '#0a0a0a', minHeight: '100vh', py: 4 }}>
      <Container maxWidth="xl">
        <Paper sx={{ p: 3, mb: 3, bgcolor: 'rgba(20,20,20,0.8)', backdropFilter: 'blur(20px)' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Avatar sx={{ width: 64, height: 64, bgcolor: '#ff6b6b' }}>
                <PersonIcon sx={{ fontSize: 40 }} />
              </Avatar>
              <Box>
                <Typography variant="h5" fontWeight={700} color="white">
                  {mockEmployee.name}
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, mt: 0.5 }}>
                  <Chip label={mockEmployee.role} size="small" sx={{ borderColor: '#ff6b6b' }} />
                  <Chip label={mockEmployee.department} size="small" sx={{ borderColor: '#00d4ff' }} />
                  <Typography variant="body2" color="text.secondary">
                    {mockEmployee.employeeId}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Chip label="Active" color="success" />
          </Box>
        </Paper>

        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ bgcolor: 'rgba(20,20,20,0.8)', backdropFilter: 'blur(20px)' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <PeopleIcon sx={{ fontSize: 40, color: '#00d4ff' }} />
                <Typography variant="h4" fontWeight={700} color="white">
                  {mockPatients.length}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Today's Patients
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ bgcolor: 'rgba(20,20,20,0.8)', backdropFilter: 'blur(20px)' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <ScheduleIcon sx={{ fontSize: 40, color: '#00d4ff' }} />
                <Typography variant="h4" fontWeight={700} color="white">
                  2
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Pending Appointments
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ bgcolor: 'rgba(20,20,20,0.8)', backdropFilter: 'blur(20px)' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <CheckIcon sx={{ fontSize: 40, color: '#00d4ff' }} />
                <Typography variant="h4" fontWeight={700} color="white">
                  156
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Total Patients
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ bgcolor: 'rgba(20,20,20,0.8)', backdropFilter: 'blur(20px)' }}>
              <CardContent sx={{ textAlign: 'center' }}>
                <MedicalIcon sx={{ fontSize: 40, color: '#00d4ff' }} />
                <Typography variant="h4" fontWeight={700} color="white">
                  8
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Years Experience
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Paper sx={{ bgcolor: 'rgba(20,20,20,0.8)', backdropFilter: 'blur(20px)' }}>
          <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} sx={{ borderBottom: 1, borderColor: 'rgba(255,255,255,0.1)' }}>
            <Tab label="Dashboard" icon={<PersonIcon />} iconPosition="start" sx={{ color: 'white' }} />
            <Tab label="Patients" icon={<PeopleIcon />} iconPosition="start" sx={{ color: 'white' }} />
            <Tab label="Schedule" icon={<CalendarIcon />} iconPosition="start" sx={{ color: 'white' }} />
            <Tab label="Settings" icon={<SettingsIcon />} iconPosition="start" sx={{ color: 'white' }} />
          </Tabs>

          <Box sx={{ p: 3 }}>
            {tabValue === 0 && (
              <Box>
                <Typography variant="h6" color="white" gutterBottom>Today's Schedule</Typography>
                <TableContainer component={Paper} sx={{ bgcolor: 'transparent' }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ color: 'white' }}>Patient Name</TableCell>
                        <TableCell sx={{ color: 'white' }}>Time</TableCell>
                        <TableCell sx={{ color: 'white' }}>Status</TableCell>
                        <TableCell sx={{ color: 'white' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {mockPatients.map((patient) => (
                        <TableRow key={patient.id}>
                          <TableCell sx={{ color: 'white' }}>{patient.name}</TableCell>
                          <TableCell sx={{ color: 'white' }}>{patient.appointment}</TableCell>
                          <TableCell>
                            <Chip 
                              label={patient.status} 
                              size="small"
                              color={
                                patient.status === 'Completed' ? 'success' :
                                patient.status === 'In Progress' ? 'warning' : 'primary'
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <Button variant="outlined" size="small" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.2)' }}>View</Button>
                            <Button variant="contained" size="small" sx={{ ml: 1, background: 'linear-gradient(135deg, #00d4ff 0%, #0066ff 100%)' }}>Start</Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            )}
            {tabValue === 1 && (
              <Box>
                <Typography variant="h6" color="white" gutterBottom>My Patients</Typography>
                <Button variant="contained" sx={{ mb: 2, background: 'linear-gradient(135deg, #00d4ff 0%, #0066ff 100%)' }}>Add New Patient</Button>
                <List>
                  {mockPatients.map((patient) => (
                    <ListItem key={patient.id} sx={{ border: '1px solid rgba(255,255,255,0.05)', borderRadius: 2, mb: 1 }}>
                      <ListItemAvatar>
                        <Avatar sx={{ bgcolor: 'rgba(0, 212, 255, 0.1)' }}>
                          <PersonIcon sx={{ color: '#00d4ff' }} />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={<Typography color="white" fontWeight={600}>{patient.name}</Typography>}
                        secondary={`Last Visit: ${patient.appointment}`}
                      />
                      <Button variant="outlined" size="small" sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.2)' }}>View Records</Button>
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            {tabValue === 2 && (
              <Box>
                <Typography variant="h6" color="white" gutterBottom>Appointment Schedule</Typography>
                <Typography color="text.secondary">Calendar view coming soon.</Typography>
              </Box>
            )}
            {tabValue === 3 && (
              <Box>
                <Typography variant="h6" color="white" gutterBottom>Settings</Typography>
                <Typography color="text.secondary">Profile settings coming soon.</Typography>
              </Box>
            )}
          </Box>
        </Paper>

        <Box sx={{ mt: 3, textAlign: 'right' }}>
          <Button 
            variant="outlined" 
            color="error"
            startIcon={<LogoutIcon />}
            onClick={() => {
              localStorage.removeItem('token');
              navigate('/');
            }}
          >
            Logout
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default EmployeePortal;
